import { CommonModule } from "@angular/common";
import { UiModule } from "@topyourthree/ui";
import * as i0 from "@angular/core";
export class ThemeButtonModule {
}
ThemeButtonModule.ɵfac = function ThemeButtonModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ThemeButtonModule)(); };
ThemeButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ThemeButtonModule });
ThemeButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, UiModule] });
